<template>
  <div class="no-results">
    <cdr-text
      tag="h2"
      class="no-results__title"
    >
      {{ title }}
    </cdr-text>
    <cdr-text class="no-results__paragraphs">
      <cdr-text
        v-if="moreInfo.paragraph"
        tag="span"
        class="no-results__paragraph"
      >
        {{ moreInfo.paragraph }}
      </cdr-text>
      <cdr-text tag="span">
        {{ moreInfo.preLink }}
      </cdr-text>
      <cdr-link
        v-bind="link.attrs"
        v-on="link.on"
      >
        {{ link.text }}
      </cdr-link>
      <cdr-text tag="span">
        {{ moreInfo.postLink }}
      </cdr-text>
    </cdr-text>
  </div>
</template>

<script>
import { CdrText, CdrLink } from '@rei/cedar';

export default {
  name: 'NoResults',
  components: {
    CdrText,
    CdrLink,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    moreInfo: {
      type: Object,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/style/components/search/no-results-component.scss';
</style>
